import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  DetectionMinimumFieldsFragment, DisplayFieldsFragment, DisplayType, useGetLiveDisplayQuery,
} from '../../../../../../../generated/core-api/graphql-react-query';
import useTimeAgo from '../../../../../../../Hooks/useTimeAgo';
import useSessionContext from '../../../../../../LiveContext/SessionContextProvider/useSessionContext';
import useLiveContext from '../../../../../../LiveContext/useLiveContext';
import PinButton from '../PinButton';
import StyledBox from './styles';

function Origin(props: { displayType: DisplayType, date: number, detection?: DetectionMinimumFieldsFragment | null }) {
  const { displayType, date, detection } = props;
  const timeAgo = useTimeAgo(date);
  const { t } = useTranslation();

  switch (displayType) {
    case DisplayType.Detection:
      return (
        <Typography variant="h4">
          <strong>{detection?.command?.name}</strong>
          {t(`currently-displayed.origin.${displayType}`, { timeAgo })}
        </Typography>
      );
    default:
      return (
        <Typography variant="h4">
          {t(`currently-displayed.origin.${displayType}`, { timeAgo })}
        </Typography>
      );
  }
}

interface InnerCurrentlyDisplayedCardProps {
  display?: DisplayFieldsFragment
}

function InnerCurrentlyDisplayedCard(props: InnerCurrentlyDisplayedCardProps) {
  const { display } = props;
  const { pinnedAt, pin, unpin } = useSessionContext();

  const { t } = useTranslation();
  return (
    <StyledBox>
      <div style={{ maxWidth: 'calc(100% - 32px)' }}>
        <Typography variant="h3" noWrap>
          {display?.card.title ?? '--'}
        </Typography>
        {display
          ? <Origin displayType={display.displayType} date={display.date} detection={display.detection} />
          : (
            <Typography variant="h4">
              <strong style={{ marginRight: 2 }}>{t('currently-displayed.empty.text-0')}</strong>
              {t('currently-displayed.empty.text-1')}
            </Typography>
          )}
      </div>
      <PinButton
        pinned={!!pinnedAt}
        disabled={display === null}
        onClick={() => { if (pinnedAt) { unpin?.(); } else { pin?.(); } }}
      />
    </StyledBox>
  );
}

export default function CurrentlyDisplayedCard() {
  const { displayId } = useLiveContext();
  const display = useGetLiveDisplayQuery({ input: { id: displayId ?? '' } }, { enabled: !!displayId });

  return (<InnerCurrentlyDisplayedCard display={display.data?.getDisplay} />);
}
